import { render, staticRenderFns } from "./lightHeader.vue?vue&type=template&id=20b0352a&scoped=true&"
import script from "./lightHeader.vue?vue&type=script&lang=js&"
export * from "./lightHeader.vue?vue&type=script&lang=js&"
import style0 from "./lightHeader.vue?vue&type=style&index=0&id=20b0352a&prod&lang=scss&"
import style1 from "./lightHeader.vue?vue&type=style&index=1&id=20b0352a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b0352a",
  null
  
)

export default component.exports